import { useStoreActions } from '~/contexts';
export const useSetAuthToken = ()=>{
    const { setAuthToken } = useStoreActions();
    return setAuthToken;
};
